export default class wt {
  constructor(t, s, i, h, l) {
    (this.triggerId = t),
      (this.Gr = s),
      (this.Br = i),
      (this.Nr = h),
      (this.Or = l),
      (this.triggerId = t),
      (this.Gr = s),
      (this.Br = i),
      (this.Nr = h),
      (this.Or = l);
  }
  static fromJson(t, s, i, h, l) {
    return null == t || null == t.trigger_id
      ? null
      : new wt(t.trigger_id, s, i, h, l);
  }
}
